<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">
          <img src="/static/img/zortout.png" alt style="max-height: 50px" />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template v-if="check_privilege('sokochan')">
          <v-btn fab outline small color="primary" v-if="!isEdit" @click="isEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn readonly fab outline small color="grey" v-on="on">
                <v-icon>lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</span>
          </v-tooltip>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('register_zortout') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('connect_zortout_service_for_more') }}</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://zortout.com/'"
            target="_blank"
            @click="step = 2"
          >
            {{ $t('register_zortout') }}</v-btn
          >

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="https://blog.zwiz.app/zortout_ordermanagement/" target="_blank">{{
              $t('how_to_use_zortout')
            }}</a>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('connect_zwiz_with_zortout') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div
            class="pa-2"
            style="position: relative; "
            :style="{ 'min-height': !check_privilege('sokochan') ? '300px' : '' }"
          >
            <v-premium-plan-popup2
              v-if="!check_privilege('sokochan')"
              type="premium"
            ></v-premium-plan-popup2>
            <div class="mb-2" v-if="showCancel">
              <div>
                {{ $t('enable_disable_zortout') }}
              </div>
              <div>
                <toggle-button
                  class="mt-2"
                  :value="setting.is_active"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="toggleStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
            </div>

            <template v-if="isEdit">
              <div class="caption">{{ $t('store_name') }}</div>
              <div class="form-control" :class="{ 'has-error': errors.has('store_name') }">
                <template>
                  <input
                    type="text"
                    v-model="setting.store_name"
                    v-validate="''"
                    name="setting.store_name"
                    data-vv-as="store_name"
                  />
                  <span class="text-error" v-if="errors.has('setting.store_name')">{{
                    errors.first('setting.store_name')
                  }}</span>
                </template>
              </div>

              <div class="caption">api key</div>
              <div class="form-control" :class="{ 'has-error': errors.has('api_key') }">
                <template>
                  <input
                    type="text"
                    v-model="setting.api_key"
                    v-validate="''"
                    name="setting.api_key"
                    data-vv-as="api_key"
                  />
                  <span class="text-error" v-if="errors.has('setting.api_key')">{{
                    errors.first('setting.api_key')
                  }}</span>
                </template>
              </div>

              <div class="caption">api secret</div>
              <div class="form-control" :class="{ 'has-error': errors.has('api_secret') }">
                <template>
                  <input
                    type="text"
                    v-model="setting.api_secret"
                    v-validate="''"
                    name="setting.api_secret"
                    data-vv-as="api_secret"
                  />
                  <span class="text-error" v-if="errors.has('setting.api_secret')">{{
                    errors.first('setting.api_secret')
                  }}</span>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="caption">{{ $t('store_name') }}</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.store_name ? setting.store_name : '-' }}
              </div>

              <div class="caption">api key</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.api_key ? setting.api_key : '-' }}
              </div>

              <div class="caption">api secret</div>
              <div v-if="!loading" class="primary--text">
                {{ setting.api_secret ? setting.api_secret : '-' }}
              </div>

              <v-btn color="primary" outline @click="generateZortoutToken()">Generate Token</v-btn>
              <template v-if="zortoutToken">
                <div class="caption">Token</div>
                <div class="primary--text">
                  {{ zortoutToken }}
                </div>
              </template>
            </template>
            <div class="text-xs-center" v-if="isEdit">
              <v-btn
                color="grey"
                outline
                @click="isEdit = false"
                v-if="showCancel"
                :loading="loading"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="primary" depressed @click="onSave" :loading="loading">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      zortoutToken: null,
      setting: {
        is_active: false,
        store_name: null,
        api_key: null,
        api_secret: null,
        endpoint_url: 'https://api.zortout.com/api.aspx',
        api_version: '3'
      },
      showCancel: true,
      step: 1
    }
  },
  async mounted() {
    this.getZortout()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async getZortout() {
      const data = {
        pageid: this.selectedBot.pageid
      }
      let response = await api.getZortout(data)
      if (response.success) {
        this.setting.api_key = response.result.api_key
        this.setting.api_secret = response.result.api_secret
        this.setting.store_name = response.result.store_name
        this.setting.is_active = response.result.is_active
        this.zortoutToken = response.result.general_token
      }
      if (response.result) {
        this.step = 2
      }
    },
    async putZortout(setting) {
      this.$store.dispatch('loading')
      const data = {
        pageid: this.selectedBot.pageid,
        body: setting
      }
      let response = await api.putZortout(data)
      if (response.success) {
        console.log(response)
        this.isEdit = false
      } else {
        this.setting.is_active = !this.setting.is_active
      }
      this.$store.dispatch('loading')
    },
    onSave() {
      this.putZortout(this.setting)
    },
    async toggleStatus() {
      const vm = this
      vm.setting.is_active = !vm.setting.is_active
      await vm.putZortout(vm.setting)
      vm.$store.state.ecommerce.products = []
    },
    async generateZortoutToken() {
      const data = {
        pageid: this.selectedBot.pageid
      }
      let response = await api.generateZortoutToken(data)
      console.log(response)
      if (response.success) {
        this.zortoutToken = response.result.general_token
      }
      if (response.result) {
        this.step = 2
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ZortOutManage.vue